var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide_bar"},_vm._l((_vm.length),function(index){return _c('div',{staticClass:"slide-bar-item",style:(_vm.styleChange(index)),on:{"click":function($event){return _vm.onSwiperTo(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }